import classes from "./styles.module.scss";
import { Component } from "react";
import React from "react";
import { MainStore } from "../../stores/MainStore";
import { observer } from "mobx-react";
import CountrySelector from "../CountrySelector";
import { Switch, Route } from "react-router";
import CountryModal from "../CountryModal";
import ContinentModal from "../ContinentModal";
interface IProps {
  store: MainStore;
}
interface IState { }
@observer
class HomeBody extends Component<IProps, IState> {
  render() {
    const { store } = this.props;
    return (
      <div className={classes.HomeBody}>
        <div className={classes.HomeBodySectionLeft}>
          <CountrySelector store={store} />
        </div>
        <div className={classes.HomeBodySectionCenter}>
          <Switch>
            <Route
              path="/continent/:id"
              render={props => <ContinentModal {...props} store={store} />}
            />
          </Switch>
        </div>
        <div className={classes.HomeBodySectionRight}>
          <Switch>
            <Route
              path="/country/:id"
              render={props => <CountryModal {...props} store={store} />}
            />
          </Switch>
        </div>
      </div>
    );
  }
}
export default HomeBody;
